import dayjs from "dayjs";
import { Button, Text, Tooltip } from "@mantine/core";
import { modals } from "@mantine/modals";
import { IconMailForward } from "@tabler/icons-react";

import { useSendTicketEmail } from "../../api/tickets";

const formatSentAt = (at) => dayjs(at).format("DD.MM.YYYY. HH:mm");

/** Whether this ticket has had the ticket email with its current code. */
export function TicketEmailState({ ticket, ...props }) {
  const text = !ticket.email
    ? "No email, so no ticket email."
    : ticket.ticketEmailSentAt
      ? `Ticket email sent ${formatSentAt(ticket.ticketEmailSentAt)}.`
      : "Ticket email not sent yet.";
  return (
    <Text size="xs" c="dimmed" data-testid="ticket-email-state" {...props}>
      {text}
    </Text>
  );
}

/**
 * "Email the ticket": the standard ticket email (the one "Send ticket emails"
 * sends) to this ticket's email. Asks first when it had it already.
 */
function EmailTicketButton({ ticket, size = "xs", variant = "default" }) {
  const { mutate, isPending } = useSendTicketEmail({ ticketId: ticket.id });
  // An empty JSON body: Fastify refuses a JSON request without one.
  const send = () => mutate({});

  const onClick = () => {
    if (!ticket.ticketEmailSentAt) return send();
    modals.openConfirmModal({
      title: "Send the ticket email again?",
      centered: true,
      children: (
        <Text size="sm">
          {`It was sent to ${ticket.email} on ${formatSentAt(ticket.ticketEmailSentAt)}. The code and link in it are the same.`}
        </Text>
      ),
      labels: { confirm: "Send again", cancel: "Cancel" },
      onConfirm: send,
    });
  };

  return (
    <Tooltip label="The ticket has no email" disabled={Boolean(ticket.email)}>
      <Button
        variant={variant}
        size={size}
        leftSection={<IconMailForward size={14} />}
        disabled={!ticket.email}
        loading={isPending}
        onClick={onClick}
      >
        Email the ticket
      </Button>
    </Tooltip>
  );
}

export default EmailTicketButton;
